require('../../modules/es.array.includes');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('Array', 'includes');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/array/includes.js
// module id = 1214
// module chunks = 1